import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
    FaPhoneAlt,
    FaEnvelope,
    FaChevronDown,
    FaChevronUp, FaCalendarDay
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick.css"; // Slick carousel styles
import "slick-carousel/slick/slick-theme.css"; // Slick carousel theme styles
import classes from "./departmentsDetail.module.css";
import classerror from "../../shared/pages/Error404Page.module.css";
import Error404Animation from "../../shared/assets/animated-placeholders/Error404.json";
import { useNavigate } from "react-router-dom";
import LottieView from "lottie-react";
import { testUrl } from "../home/BaseData";

const DepartmentDetails = () => {
    const { short_id } = useParams();
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(); // Access i18n instance
    const [data, setData] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [boss, setBoss] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openDropdown, setOpenDropdown] = useState({});



    useEffect(() => {
        setError(null);
        setLoading(true);
        const fetchDepartment = axios.get(
            testUrl + "/api/centers/" + short_id
        );
        Promise.all([fetchDepartment])
            .then(([departmentResponse]) => {
                const responseData = departmentResponse.data;
                if (responseData?.department) {
                    setData(responseData.department);
                    setDepartments(responseData.departments || []);
                    setBoss(responseData.boss?.[0] || null);
                    setEmployees(responseData.employees || []);
                } else {
                    setError("data_not_found");
                }
            })
            .catch(() => setError("loading_error"))
            .finally(() => setLoading(false));
    }, [short_id, i18n.language]);

    const nameToKey = {
        "Xalqaro hamkorlik bo‘yicha prorektor": "prorektor_xalqaro",
        "Xalqaro hamkorlik va reytinglar bilan ishlash boshqarmasi": "boshqarma_xalqaro",
        "Xorijiy ta’lim hamkorligi markazlari rahbari-prorektor": "prorektor_xorijiy",
        "Rektor apparati – rektor yordamchisi va maslahatchilari": "rektor_apparati",
        "Inson resurslarini boshqarish boshqarmasi": "boshqarma_inson_resurslari",
        "Universitet axborot xizmati": "axborot_xizmati_uni",
        "Yuriskonsult, “Komplayens nazorat”": "yuriskonsult_komplayens",
        "Kengashlar va majlislar kotibi": "kotib_kengashlar",
        "Ijro intizomi, arxiv va murojaatlar bilan ishlash bo‘limi": "bolim_ijro_intizomi",
        "Yoshlar bilan ishlash, ma’naviyat va ma’rifat boshqarmasi": "boshqarma_yoshlar",
        "Axborot-resurs markazi": "axborot_resurs_markazi_uni",
        "Tyutorlar faoliyatini muvoxiqlashtirish bo‘limi": "bolim_tyutorlar",
        "Psixolog": "psixolog",
        "Yoshlar uyushmasi, klublar va to‘garaklar": "klublar_togaraklar",
        "Sport klubi kotibi": "sport_klubi_kotibi",
        "Ilmiy tadqiqotlar, innovatsiyalar, ilmiy-pedagog kadrlarni tayyorlash va iqtidorli talabalar bilan ishlash boshqarmasi": "boshqarma_ilmiy",
        "Buxgalteriya": "buxgalteriya",
        "Ishlar boshqarmasi": "ishlar_boshqarmasi",
        "Bosh muhandis-texnolog": "muhandis_texnolog",
        "Texnik foydalanish va xo‘jalik bo‘limi": "bolim_xo'jalik"
    };

    const getTranslatedContent = (item, prefix) => {
        const uzName = item[`${prefix}_uz`];
        if (uzName && nameToKey[uzName]) {
            return t(nameToKey[uzName]);
        }
        return item[`${prefix}_${i18n.language}`] || uzName || '';
    };


    // Get the first staff member
    const toggleDropdown = (id, type) => {
        setOpenDropdown((prev) => ({
            ...prev,
            [id]: {
                activities: type === "activities" ? !prev[id]?.activities : false,
                responsibilities:
                    type === "responsibilities" ? !prev[id]?.responsibilities : false,
            },
        }));
    };

    const getDepartmentName = (department) => {
        if (!department) return t("no_name_available");
        return getTranslatedContent(department, 'name');
    };

    if (loading) return <p>{t("loading")}</p>;
    if (error) return (
        <div className={classerror["error-page"]}>
            <LottieView className={classerror["animation"]}
                animationData={Error404Animation}
                loop={true}
            />
            <p className={classerror["title"]}>
                {t(error)}
            </p>
            <p className={classerror["description"]}>
                {t("back_main")}
            </p>
            <div onClick={() => navigate("/")} className={classerror["button"]}>
                {t("main_menu")}
            </div>
        </div>
    )
    if (!data) return <p></p>;

    return (
        <div className={classes.mainContainer}>
            <div data-aos="fade-up" className={classes["rahbariyat-container"]}>

                <h1 className={classes["page-title"]}>
                    {data && getTranslatedContent(data, 'name')}
                </h1>
                <div className="ck-content" dangerouslySetInnerHTML={{
                    __html: data && data[`about_${i18n.language}`] ? data[`about_${i18n.language}`] : '',
                }} />
                {/* <h2 className={classes.sectionTitle}>{t("staff_title")}</h2> */}
                {boss && <div className={`${classes.card}`} key={boss.employee?.id} onClick={() => navigate(`/employee/${boss.employee?.id}`)} style={{ cursor: 'pointer' }}>
                    <div className={classes.headerRight}>
                        <div className={classes.info}>
                            <h2>
                                {boss.employee && boss.employee[`name_${i18n.language}`]}
                            </h2>
                            <p>
                                {t("position")}
                                {boss && boss[`position_${i18n.language}`]}
                            </p>
                            <div className={classes.contact}>
                                <div className={classes.contactItem}>
                                    <FaEnvelope className={classes.icon2} />
                                    <span>{boss.employee?.email}</span>
                                </div>
                                <div className={classes.contactItem}>
                                    <FaCalendarDay className={classes.icon} />
                                    <span>
                                        {t("ish_staj")}
                                        {boss.employee && boss.employee[`work_experience_${i18n.language}`]}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className={classes.imageWrapper}>
                            <img src={boss.employee?.image} // Fallback to default image if not available
                                alt={boss.employee && boss.employee[`name_${i18n.language}`]}
                                className={classes.logo} />
                        </div>
                    </div>
                </div>
                }

                {employees && employees.filter(e => e !== null && e.employee != null).map((employee, index) => (
                    <div
                        className={`${classes.card} ${index === 0 ? classes.highlightedCard : ""
                            }`}
                        key={employee.id}
                        onClick={() => navigate(`/employee/${employee.employee?.id}`)}
                        style={{ cursor: 'pointer' }}>
                        <div className={classes.headerLeft}>
                            <div className={classes.info}>
                                <h2>{employee.employee?.[`name_${i18n.language}`] || employee.employee?.name_uz || ''}</h2>
                                <p>
                                    {t("position")}
                                    {getTranslatedContent(employee, 'position')}
                                </p>
                                <div className={classes.contact}>
                                    <div className={classes.contactItem}>
                                        <FaEnvelope className={classes.icon2} />
                                        <span>{employee.employee?.email}</span>
                                    </div>
                                    {employee.employee?.[`work_experience_${i18n.language}`] && (
                                        <div className={classes.contactItem}>
                                            <FaCalendarDay className={classes.icon} />
                                            <span>
                                                {t("ish_staj")}
                                                {employee.employee?.[`work_experience_${i18n.language}`]}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className={classes.imageWrapper}>
                                <img src={employee.employee?.image || ""} // Fallback to default image if not available
                                    alt={employee.employee?.[`name_${i18n.language}`] || ''}
                                    className={classes.logo} />
                            </div>
                        </div>
                    </div>
                ))
                }
            </div>

            <div className={classes.sidebar} style={{ marginLeft: 0, marginRight: "40px" }}>
                <h3>{t("center")}</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    {departments && departments.length > 0 ? (
                        departments.filter(department => department !== null).map((department, index) => (
                            <li
                                onClick={() => navigate(`/centers/${department.short_id}`)}
                                key={department.id}
                                style={{ marginBottom: '10px' }}
                                className={department.short_id === short_id ? classes.active : ''}
                            >
                                <span style={{
                                    marginRight: '8px',
                                    color: '#133654',
                                    fontWeight: 'bold'
                                }}>{index + 1}.</span>
                                <span
                                    style={{ cursor: 'pointer', color: '#133654' }}
                                >
                                    {getDepartmentName(department)}
                                </span>
                            </li>
                        ))
                    ) : (
                        <li>{t("no_departments_found")}</li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default DepartmentDetails;